import {NgModule} from '@angular/core';
import {CommonModule as NGCommonModule} from '@angular/common';
import {CommonModule} from '../common/common.module';
import {RealTimeRoutingModule} from './real-time.routing';
import {RealTimeComponent} from './real-time/real-time.component';
import {RealTimeCounterComponent} from './real-time-counter/real-time-counter.component';
import {RealTimeService} from './real-time/real-time.service';
import {RealTimeContextService} from './real-time-context.service';
import {RealTimePopupComponent} from './real-time/real-time-popup/real-time-popup.component';
import {RealTimeDetailComponent} from './real-time-detail/real-time-detail.component';
import {RealTimeRegionPopupComponent} from './real-time/real-time-region-popup/real-time-region-popup.component';
import {UpcomingEventsHeaderComponent} from './upcoming-events-header/upcoming-events-header.component';
import {StatsService} from './stats.service';
import {RealTimeServiceLevelsPopupComponent} from './real-time/real-time-service-levels-popup/real-time-service-levels-popup.component';
import {RealTimeLegendComponent} from './real-time-legend/real-time-legend.component';
import {MobilePopupComponent} from './mobile-popup/mobile-popup.component';
import {RealTimeMenuComponent} from './real-time/real-time-menu/real-time-menu.component';

@NgModule({
    imports: [
        NGCommonModule,
        CommonModule,
        RealTimeRoutingModule
    ],
    declarations: [
        RealTimeComponent,
        RealTimeCounterComponent,
        RealTimePopupComponent,
        RealTimeDetailComponent,
        RealTimeRegionPopupComponent,
        UpcomingEventsHeaderComponent,
        RealTimeServiceLevelsPopupComponent,
        RealTimeLegendComponent,
        RealTimeMenuComponent,
        MobilePopupComponent
    ],
    providers: [RealTimeService, StatsService, RealTimeContextService],
    entryComponents: [RealTimePopupComponent, RealTimeRegionPopupComponent, RealTimeServiceLevelsPopupComponent]
})
export class RealTimeModule {
}



// WEBPACK FOOTER //
// ./src/app/real-time/real-time.module.ts